/**
 * @description: Copied from https://git.perkbox.io/perkbox-services/core/core-app/-/blob/master/public/error_codes/errors.go
 */

enum Core {
  BusinessNotFound = "PBCOREBusinessNotFound",
  DeleteTeamNotAllowed = "PBCOREDeleteTeamNotAllowed",
  DuplicateValue = "PBCOREDuplicateValue",
  EmailAlreadyExists = "PBCOREEmailAlreadyExists",
  EmptyField = "PBCOREEmptyField",
  GroupNotFound = "PBCOREGroupNotFound",
  InvalidBrandingField = "PBCOREInvalidBrandingField",
  InvalidDOB = "PBCOREInvalidDOB",
  InvalidEmail = "PBCOREInvalidEmail",
  InvalidFeatureFlag = "PBCOREInvalidFeatureFlag",
  InvalidFirstName = "PBCOREInvalidFirstName",
  InvalidGender = "PBCOREInvalidGender",
  InvalidLanguage = "PBCOREInvalidLanguage",
  InvalidLastName = "PBCOREInvalidLastName",
  InvalidName = "PBCOREInvalidName",
  InvalidNotBeforeDate = "PBCOREInvalidNotBeforeDate",
  InvalidParentId = "PBCOREInvalidParentId",
  InvalidParentState = "PBCOREInvalidParentState",
  InvalidPhoneNumber = "PBCOREInvalidPhoneNumber",
  InvalidPrimaryTeam = "PBCOREInvalidPrimaryTeam",
  InvalidProfileImage = "PBCOREInvalidProfileImage",
  InvalidSearch = "PBCOREInvalidSearch",
  InvalidSource = "PBCOREInvalidSource",
  InvalidSSOButtonText = "PBCOREInvalidSSOButtonText",
  InvalidState = "PBCOREInvalidState",
  InvalidSubdomain = "PBCOREInvalidSubdomain",
  InvalidSupervisor = "PBCOREInvalidSupervisor",
  InvalidTier = "PBCOREInvalidTier",
  InvalidUserRoleMapping = "PBCOREInvalidUserRoleMapping",
  InvalidUserTeamMapping = "PBCOREInvalidUserTeamMapping",
  PrimaryTeamBlocked = "PBCOREPrimaryTeamBlocked",
  RequestTooBig = "PBCORERequestTooBig",
  RoleNotAllowed = "PBCORERoleNotAllowed",
  RoleNotFound = "PBCORERoleNotFound",
  SubdomainAlreadyExists = "PBCORESubdomainAlreadyExists",
  TeamNotFound = "PBCORETeamNotFound",
  TooManyGroups = "PBCORETooManyGroupings",
  TooManyRoles = "PBCORETooManyRoles",
  TooManyTeams = "PBCORETooManyTeams",
  TooManyTeamsAndRoles = "PBCORETooManyTeamsAndRoles",
  UnknownField = "PBCOREUnknownField",
  UpdateFieldForbidden = "PBCOREUpdateFieldForbidden",
  UserNotFound = "PBCOREUserNotFound",
  Declined = "PBCOREDeclined"
}

export default Core
